var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: {
        "view-room-details-table": true,
        "room-unavailable": !_vm.roomIsAvailable,
        "showing-strike-through": _vm.$store.getters.showingPreferredOffer,
      },
    },
    [
      _c("h2", [
        _c("span", [_vm._v("Order " + _vm._s(_vm.currentViewText))]),
        _vm._v(" "),
        _c("div", { staticClass: "clearme" }),
        _vm._v(" "),
        !_vm.$store.getters.isOnlyShowAvailability
          ? _c(
              "a",
              {
                staticClass: "change-view",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggleMode.apply(null, arguments)
                  },
                },
              },
              [_vm._v("View " + _vm._s(_vm.changeViewText))]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("table", { attrs: { role: "presentation" } }, [
        _c("tbody", [
          _c("tr", [
            _c(
              "td",
              {
                staticClass: "title",
                attrs: { "data-tooltip": "Use buttons to change." },
              },
              [_vm._v("Adults")]
            ),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "display-NUM-OF-ADULTS", attrs: { colspan: "2" } },
              [
                _c("span", { staticClass: "control" }, [
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t\t\t\t" +
                        _vm._s(_vm.$store.state.bookingLinkData.adults) +
                        "\n\t\t\t\t\t\t\t\t\t"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      class: {
                        decrement: true,
                        disabled:
                          _vm.$store.state.adultMin ===
                          _vm.$store.state.bookingLinkData.adults,
                      },
                      attrs: {
                        title: "Decrement number of adults",
                        href: "#view-room-details-table",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.$store.commit("decrementAdults")
                        },
                        mousedown: _vm.controlMousedown,
                        mouseup: _vm.controlMouseup,
                      },
                    },
                    [
                      _c("svg", [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#symbol_remove_circle",
                          },
                        }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      class: {
                        increment: true,
                        disabled:
                          _vm.$store.state.adultMax ===
                          _vm.$store.state.bookingLinkData.adults,
                      },
                      attrs: {
                        title: "Increment number of adults",
                        href: "#view-room-details-table",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.$store.commit("incrementAdults")
                        },
                        mousedown: _vm.controlMousedown,
                        mouseup: _vm.controlMouseup,
                      },
                    },
                    [
                      _c("svg", [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#symbol_add_circle",
                          },
                        }),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c(
              "td",
              {
                staticClass: "title",
                attrs: { "data-tooltip": "Use buttons to change." },
              },
              [_vm._v("Children")]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "display-NUM-OF-CHILDREN",
                attrs: { colspan: "2" },
              },
              [
                _c("span", { staticClass: "control" }, [
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t\t\t\t" +
                        _vm._s(_vm.$store.state.bookingLinkData.children) +
                        "\n\t\t\t\t\t\t\t\t\t"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      class: {
                        decrement: true,
                        disabled:
                          _vm.$store.state.childMin ===
                          _vm.$store.state.bookingLinkData.children,
                      },
                      attrs: {
                        title: "Decrement number of children",
                        href: "#view-room-details-table",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.$store.commit("decrementChildren")
                        },
                        mousedown: _vm.controlMousedown,
                        mouseup: _vm.controlMouseup,
                      },
                    },
                    [
                      _c("svg", [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#symbol_remove_circle",
                          },
                        }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      class: {
                        increment: true,
                        disabled:
                          _vm.$store.state.childMax ===
                          _vm.$store.state.bookingLinkData.children,
                      },
                      attrs: {
                        title: "Increment number of children",
                        href: "#view-room-details-table",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.$store.commit("incrementChildren")
                        },
                        mousedown: _vm.controlMousedown,
                        mouseup: _vm.controlMouseup,
                      },
                    },
                    [
                      _c("svg", [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#symbol_add_circle",
                          },
                        }),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "mobile-hidden" }, [
            _c("td", { staticClass: "title" }, [_vm._v("Check-In")]),
            _vm._v(" "),
            _c("td", {
              staticClass: "display-CHECK-IN-DATE",
              domProps: { innerHTML: _vm._s(_vm.checkInDateDisplay) },
            }),
            _vm._v(" "),
            _c("td", { attrs: { align: "right", rowspan: "2" } }, [
              _c(
                "a",
                {
                  staticClass: "change-dates",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.openCalendar.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.calendarOpen,
                          expression: "!calendarOpen",
                        },
                      ],
                    },
                    [_vm._v("Change"), _c("br"), _vm._v("Dates")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.calendarOpen,
                          expression: "calendarOpen",
                        },
                      ],
                    },
                    [_vm._v("Close")]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "mobile-hidden" }, [
            _c("td", { staticClass: "title" }, [_vm._v("Check-Out")]),
            _vm._v(" "),
            _c("td", {
              staticClass: "display-CHECK-OUT-DATE",
              domProps: { innerHTML: _vm._s(_vm.checkOutDateDisplay) },
            }),
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "mobile-only" }, [
            _c("td", [_vm._v(" ")]),
            _vm._v(" "),
            _c("td", { attrs: { colspan: "2" } }, [
              _c(
                "a",
                {
                  staticClass: "change-dates",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.openCalendar.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.calendarOpen,
                          expression: "!calendarOpen",
                        },
                      ],
                    },
                    [_vm._v("Change Dates")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.calendarOpen,
                          expression: "calendarOpen",
                        },
                      ],
                    },
                    [_vm._v("Close")]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "mobile-only" }, [
            _c("td", { staticClass: "title" }, [_vm._v("Check-In")]),
            _vm._v(" "),
            _c("td", {
              staticClass: "display-CHECK-IN-DATE",
              attrs: { colspan: "2" },
              domProps: { innerHTML: _vm._s(_vm.checkInDateDisplay) },
            }),
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "mobile-only" }, [
            _c("td", { staticClass: "title" }, [_vm._v("Check-Out")]),
            _vm._v(" "),
            _c("td", {
              staticClass: "display-CHECK-OUT-DATE",
              attrs: { colspan: "2" },
              domProps: { innerHTML: _vm._s(_vm.checkOutDateDisplay) },
            }),
          ]),
          _vm._v(" "),
          _c(
            "tr",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.calendarOpen,
                  expression: "calendarOpen",
                },
              ],
              class: {
                "check-in-out-calendar": true,
                "show-loading-spinner": !_vm.calendarLoaded && _vm.calendarOpen,
              },
            },
            [
              _c(
                "td",
                { attrs: { colspan: "3" } },
                [
                  _c(_vm.calendarComponent, {
                    ref: "calendar",
                    tag: "component",
                    attrs: {
                      "change-dates-callback": _vm.changeDatesCallback,
                      "disallow-sold-out-dates": "",
                      "is-display-vertical": "",
                      "offer-code":
                        _vm.$store.state.bookingLinkData.offerCode || "",
                      "is-blackout-calendar":
                        _vm.$store.getters.isOnlyShowAvailability,
                    },
                    on: {
                      close: function ($event) {
                        _vm.calendarOpen = false
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      !_vm.$store.getters.isOnlyShowAvailability
        ? [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.summaryMode,
                    expression: "summaryMode",
                  },
                ],
                staticClass: "summary",
              },
              [
                _c("table", { attrs: { role: "presentation" } }, [
                  _c("tbody", [
                    _c("tr", { staticClass: "mobile-hidden" }, [
                      _c("td", { staticClass: "title" }, [
                        _c(
                          "a",
                          {
                            staticClass: "change-view",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.toggleMode.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("View Daily Rates")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(" ")]),
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "mobile-only" }, [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "change-view",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.toggleMode.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("View Taxes/Fees")]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "title" }, [
                        _vm._v("Room Subtotal"),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "display-ROOM-SUBTOTAL" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$store.state.currentSubtotal) +
                            "\n              "
                        ),
                        _vm.strikeThroughSubtotal > 0
                          ? _c(
                              "span",
                              { staticClass: "strike less-emphasis" },
                              [_vm._v(_vm._s(_vm.currentSubtotalStrikeThrough))]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "title" }, [_vm._v("Room Tax")]),
                      _vm._v(" "),
                      _c("td", { staticClass: "display-STATE-TAX" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$store.state.currentStateTax)),
                        ]),
                        _vm._v(" "),
                        _vm.strikeThroughStateTax > 0
                          ? _c(
                              "span",
                              { staticClass: "strike less-emphasis" },
                              [_vm._v(_vm._s(_vm.currentStateTaxStrikeThrough))]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "title" }, [
                        _vm._v("Resort Fee"),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "display-RESORT-FEE" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$store.state.currentResortFee)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "info",
                            attrs: { title: "Resort Fee", href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.showTooltipResortFee.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("svg", [
                              _c("use", {
                                attrs: {
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  "xlink:href": "#symbol_info",
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "title" }, [
                        _vm._v("Resort Fee Tax"),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "display-RESORT-FEE-TAX" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$store.state.currentResortFeeTax)),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "title" }, [
                        _vm._v("Tourism Surcharge"),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "display-TOURISM-SURCHARGE" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$store.state.currentTourismSurcharge)
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "info",
                            attrs: { title: "Tourism Surcharge", href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.showTooltipTourismSurcharge.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("svg", [
                              _c("use", {
                                attrs: {
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  "xlink:href": "#symbol_info",
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("td", { staticClass: "display-TOTAL" }, [
                        _c("strong", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$store.state.currentTotal)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.strikeThroughTotal > 0
                          ? _c(
                              "span",
                              { staticClass: "strike less-emphasis" },
                              [_vm._v(_vm._s(_vm.currentTotalStrikeThrough))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "info",
                            attrs: { title: "Display Total", href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.showTooltipTotal.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("svg", [
                              _c("use", {
                                attrs: {
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  "xlink:href": "#symbol_info",
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.$store.getters.showingPreferredOffer &&
                    _vm.preferredRateDifference.length
                      ? _c("tr", { staticClass: "preferred-savings" }, [
                          _c("td", { staticClass: "title" }, [
                            _vm._v("Preferred Savings!"),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "span",
                              { staticClass: "preferred-savings-display" },
                              [_vm._v(_vm._s(_vm.preferredRateDifference))]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.summaryMode,
                    expression: "!summaryMode",
                  },
                ],
                staticClass: "details",
              },
              [
                _c("table", { attrs: { role: "presentation" } }, [
                  _c(
                    "tbody",
                    [
                      _c("tr", [
                        _c("td", { staticClass: "title" }, [_vm._v("Nights")]),
                        _vm._v(" "),
                        _c("td", { staticClass: "display-NUM-OF-NIGHTS" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$store.state.bookingLinkData.stayLength
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.dailyRates, function (rate) {
                        return _c(
                          "tr",
                          {
                            staticClass: "daily-rate",
                            attrs: { "data-rate-date": rate.date },
                          },
                          [
                            _c("td", {
                              staticClass: "title",
                              domProps: { innerHTML: _vm._s(rate.displayDate) },
                            }),
                            _vm._v(" "),
                            _c("td", [
                              _c("span", [_vm._v(_vm._s(rate.price))]),
                              _vm._v(" "),
                              rate.priceStrikeThrough.length
                                ? _c(
                                    "span",
                                    { staticClass: "strike less-emphasis" },
                                    [_vm._v(_vm._s(rate.priceStrikeThrough))]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticClass: "title" }, [
                          _vm._v("Room Subtotal"),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "display-ROOM-SUBTOTAL" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$store.state.currentSubtotal) +
                              "\n              "
                          ),
                          _vm.strikeThroughSubtotal > 0
                            ? _c(
                                "span",
                                { staticClass: "strike less-emphasis" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.currentSubtotalStrikeThrough)
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticClass: "title" }, [
                          _vm._v("Room Tax"),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "display-STATE-TAX" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$store.state.currentStateTax)),
                          ]),
                          _vm._v(" "),
                          _vm.strikeThroughStateTax > 0
                            ? _c(
                                "span",
                                { staticClass: "strike less-emphasis" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.currentStateTaxStrikeThrough)
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticClass: "title" }, [
                          _vm._v("Resort Fee"),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "display-RESORT-FEE" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$store.state.currentResortFee)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "info",
                              attrs: { title: "Resort Fee", href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.showTooltipResortFee.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("svg", [
                                _c("use", {
                                  attrs: {
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    "xlink:href": "#symbol_info",
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticClass: "title" }, [
                          _vm._v("Resort Fee Tax"),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "display-RESORT-FEE-TAX" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$store.state.currentResortFeeTax)
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticClass: "title" }, [
                          _vm._v("Tourism Surcharge"),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "display-TOURISM-SURCHARGE" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$store.state.currentTourismSurcharge)
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "info",
                              attrs: { title: "Tourism Surcharge", href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.showTooltipTourismSurcharge.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("svg", [
                                _c("use", {
                                  attrs: {
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    "xlink:href": "#symbol_info",
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("td", { staticClass: "display-TOTAL" }, [
                          _c("strong", [
                            _c("span", [_vm._v(_vm._s(_vm.currentTotal))]),
                          ]),
                          _vm._v(" "),
                          _vm.strikeThroughTotal > 0
                            ? _c(
                                "span",
                                { staticClass: "strike less-emphasis" },
                                [_vm._v(_vm._s(_vm.currentTotalStrikeThrough))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "info",
                              attrs: { title: "Show Total", href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.showTooltipTotal.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("svg", [
                                _c("use", {
                                  attrs: {
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    "xlink:href": "#symbol_info",
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.$store.getters.showingPreferredOffer
                        ? _c("tr", { staticClass: "preferred-savings" }, [
                            _c("td", { staticClass: "title" }, [
                              _vm._v("Preferred Savings!"),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "span",
                                { staticClass: "preferred-savings-display" },
                                [_vm._v(_vm._s(_vm.preferredRateDifference))]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", { staticClass: "title" }, [_c("strong", [_vm._v("Total")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", { staticClass: "title" }, [_c("strong", [_vm._v("Total")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }